module.exports = __webpack_public_path__ + "media/images/icons/icons_large/56_diamond-a4216b7059813a262545239791e2c660.png";